//Generated File 
export default class ChatParticipantRole{
	static readonly Admin = `Admin`;
	static readonly Blocked = `Blocked`;
	static readonly Guest = `Guest`;
	static readonly Member = `Member`;
}
